import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CmsActivatedRouteSnapshot, ProductScope, ProductService } from '@spartacus/core';
import { first, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductGuard implements CanActivate {
  constructor(private router: Router, private productService: ProductService) {}
  currentProductUrl = '';
  canActivate(route: CmsActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const productCode: string = route?.params?.productCode;
    if (productCode) {
      return this.productHasReplaceUrl(productCode);
    } else {
      return of(true);
    }
  }

  private productHasReplaceUrl(productCode: string): Observable<boolean | UrlTree> {
    return this.productService.hasError(productCode, ProductScope.DETAILS).pipe(
      switchMap((err) => {
        if (err) {
          return of(null);
        }
        return this.productService.get(productCode, ProductScope.DETAILS).pipe(first((p) => !!p));
      }),
      map((product) => {
        if (product?.replacedBy && product?.replacedBy.url !== this.currentProductUrl) {
          this.currentProductUrl = product.url;
          return this.router.parseUrl(product.replacedBy.url);
        } else {
          this.currentProductUrl = '';
          return true;
        }
      })
    );
  }
}
